import styled from "styled-components";
import { MOBILE_L_BP } from "@website-builder/utilities-index";

export const ModalWrapper = styled.div`
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.request-syllabus-modal-wrapper {
			padding: 45px;
		}
	}
`;

export const ModalContent = styled.div`
	& > * {
		color: var(--primary-neutral-nightshade-800);
	}
	.callUs {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2rem;
		max-width: 400px;
	}
	.email {
		max-width: 450px;
		h5 {
			margin-bottom: 2rem;
		}
	}
	a {
		color: var(--primary-neutral-nightshade-800);
	}
	.successMessageWrapper {
		display: flex;
		align-items: center;
		img {
			margin-right: 10px;
		}

		.message {
			margin-left: 1rem;
		}
	}

	.emailConfirmCheckbox {
		margin: 1rem 0;
		display: flex;
		align-items: flex-start;
		cursor: pointer;

		input {
			height: 16px;
			width: 32px;
			margin-right: 8px;
		}

		&.invalid input {
			outline: 2px solid var(--secondary-red-200);
		}

		span {
			margin: 0 0 0 0.5rem;
			text-align: left;
			&::after {
				margin-left: 0.25rem;
				content: "*";
				color: var(--secondary-red-300);
			}
		}

		a > p {
			margin: 0;
		}
	}

	.errorMessage {
		color: var(--secondary-red-300);
		text-align: center;
	}
`;
